'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotScatterAxesIcon = function PlotScatterAxesIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M29.375 28.375H5.062c-.75 0-1.438-.625-1.438-1.375V2.625c0-.563-.438-1-1-1s-1 .438-1 1V27c0 1.875 1.5 3.375 3.438 3.375h24.375c.563 0 1-.438 1-1s-.5-1-1.063-1zm-18.437-6.312c0 1-.813 1.75-1.75 1.75s-1.75-.75-1.75-1.75c0-.938.813-1.688 1.75-1.688s1.75.75 1.75 1.688zm6.312-9.25c0 1-.75 1.75-1.75 1.75-.938 0-1.688-.75-1.688-1.75 0-.938.75-1.688 1.688-1.688 1 0 1.75.75 1.75 1.688zm2.188 6.812c0 1-.75 1.75-1.688 1.75-1 0-1.75-.75-1.75-1.75 0-.938.75-1.688 1.75-1.688.938 0 1.688.75 1.688 1.688zm4.875-5.562c0 .938-.75 1.688-1.75 1.688-.938 0-1.688-.75-1.688-1.688s.75-1.75 1.688-1.75c1 0 1.75.813 1.75 1.75zM27 7.5c0 .938-.813 1.688-1.75 1.688S23.5 8.438 23.5 7.5s.813-1.75 1.75-1.75S27 6.563 27 7.5z' })
    );
};

exports.default = PlotScatterAxesIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotScatterAxesIcon.js
// module id = 680
// module chunks = 0